import { getCurrentPracticeId, getCurrentUserInfo } from '../lib/api';
import { db } from "../lib/db";

/**
 * Log a HIPAA audit event.
 *
 * @param {string} action        - e.g. 'view', 'create', 'update', 'sign', 'archive', 'print', 'fax', 'login', 'logout'
 * @param {string} resourceType  - e.g. 'patient', 'note', 'medication', 'document', 'lab_order', 'imaging', 'charge', 'session'
 * @param {string} resourceId    - the id of the resource being acted on
 * @param {string|null} patientId - patient context (null for session events)
 * @param {object} details       - any additional context (note_type, drug name, etc.)
 */
export const logAudit = async (action, resourceType, resourceId, patientId = null, details = {}) => {
  try {
    const pid = await getCurrentPracticeId();
    const { uid, email } = await getCurrentUserInfo();
    if (!pid && !uid) return;

    await db.from('audit_log').insert({
      practice_id:   pid || null,
      user_id:       uid,
      user_email:    email,
      action,
      resource_type: resourceType,
      resource_id:   resourceId ? String(resourceId) : null,
      patient_id:    patientId  ? String(patientId)  : null,
      details,
    });
  } catch (err) {
    // Audit failures must never break the app
    console.error('Audit log error:', err);
  }
};
